import { Card } from '@/components/ui/Card'
import type { SuggestedProgram } from '@/types'

/**
 * Suggested programs the client does not have yet (PC-31), under the segment
 * rail. Clicking one opens the add program drawer with its name filled in;
 * nothing is added until the drawer is saved. Hidden once every suggestion is taken.
 */
export function ProgramQuickAdd({
  suggestions,
  onPick,
}: {
  suggestions: SuggestedProgram[]
  onPick: (name: string) => void
}) {
  if (suggestions.length === 0) return null
  return (
    <Card className="overflow-hidden">
      <div className="border-b border-rule px-3 py-2">
        <p className="field-label">Program Quick Add</p>
      </div>
      <ul aria-label="Suggested programs" className="flex flex-wrap gap-1 p-2.5">
        {suggestions.map((s) => (
          <li key={s.name}>
            <button
              type="button"
              onClick={() => onPick(s.name)}
              className="rounded-[4px] border border-rule px-1.5 py-0.5 text-[12px] hover:bg-surface-sunk"
            >
              {s.name}
            </button>
          </li>
        ))}
      </ul>
    </Card>
  )
}
